import WebForm from './web_form_class';
import make_datatable from './grid_list';

frappe.ready(function() {
	if(web_form_settings.is_list) {
		$('body').show();
		if($('.web-form-list').length) {
			make_datatable('.web-form-list', web_form_settings.web_form_doctype);
		}
		return;
	}

	frappe.form_dirty = false;
	$.extend(frappe, web_form_settings);
	moment.defaultFormat = frappe.moment_date_format;
	$('[data-toggle="tooltip"]').tooltip();

	const { web_form_doctype: doctype, doc_name: docname, web_form_name } = web_form_settings;
	const wrapper = $(`.webform-wrapper`);
	var $form = $("div[data-web-form='"+frappe.web_form_name+"']");

	// :( Needed by core model, meta and perm, all now included in th website js
	// One of the few non-touchy options
	frappe.boot.user = {
		can_read: '', can_write: '', can_create: ''
	};

	frappe.web_form = new WebForm({
		wrapper: wrapper,
		doctype: doctype,
		docname: docname,
		web_form_name: web_form_name,
		allow_incomplete: frappe.allow_incomplete
	});

	setTimeout(() => {
		$('body').css('display', 'block');

		// remove footer save button if form height is less than window height
		if($('.webform-wrapper').height() < window.innerHeight) {
			$(".footer-button").addClass("hide");
		}

		if (frappe.init_client_script) {
			frappe.init_client_script();

			if (frappe.web_form.after_load) {
				frappe.web_form.after_load();
			}
		}
	}, 500);

	// allow payment only if
	$('.btn-payment').on('click', function() {
		save(true);
		return false;
	});

	// submit
	$(".btn-form-submit").on("click", function() {
		save();
		return false;
	});

	// change section
	$('.btn-change-section, .slide-progress .fa-fw').on('click', function() {
		var idx = $(this).attr('data-idx');
		if(!frappe.form_dirty || frappe.is_read_only) {
			show_slide(idx);
		} else {
			if(save() !== false) {
				show_slide(idx);
			}
		}
		return false;
	});

	var show_slide = function(idx) {
		// hide all sections
		$('.web-form-page').addClass('hidden');

		// slide-progress
		$('.slide-progress .fa-circle')
			.removeClass('fa-circle').addClass('fa-circle-o');
		$('.slide-progress .fa-fw[data-idx="'+idx+'"]')
			.removeClass('fa-circle-o').addClass('fa-circle');

		// un hide target section
		$('.web-form-page[data-idx="'+idx+'"]')
			.removeClass('hidden')
			.find(':input:first').focus();

	};

    function logClientError(data) {
        frappe.call({
            method: "wela.payment_link.log_client_error",
            args: {
                error_context: JSON.stringify(data)
            }
        });
    };

    function processPaymentLink(data, preEnrollmentName, retryCount) {
        const MAX_RETRIES = 3; // Set a limit to prevent infinite loops
        frappe.call({
        method: "wela.payment_link.get_url_",
        args: {
            last_name: data.last_name.trim(),
            first_name: data.first_name.trim(),
            description: "Enrollment Payment",
            incoming_level: data.incoming_level,
            school_code: "HCCD",
            number: data.guardian_phone_number,
            amount: data.initial_payment,
            pre_enrollment: preEnrollmentName
        },
        freeze: true,
        freeze_message: "Processing... Please wait...",
        callback: function (r) {
            if (r.message === "Failed") {
                if (retryCount < MAX_RETRIES) {
                    processPaymentLink(data, preEnrollmentName, retryCount + 1); // Retry the function
                } else {
                    logClientError({
                        message: "Failed to generate payment link after retries.",
                        data: data,
                        preEnrollmentName: preEnrollmentName
                    });
                }
            } else {
                window.location.href = r.message; // Redirect on success
            }
         }
        });
    }

    function processPaymentLinkRedirect(data, preEnrollmentName, retryCount) {
        const MAX_RETRIES = 3; // Set a limit to prevent infinite loops
        frappe.call({
        method: "wela.payment_link.get_url_",
        args: {
            last_name: data.last_name.trim(),
            first_name: data.first_name.trim(),
            description: "Enrollment Payment",
            incoming_level: data.incoming_level,
            school_code: "HCCD",
            number: data.guardian_phone_number,
            amount: data.initial_payment,
            pre_enrollment: preEnrollmentName
        },
        freeze: true,
        freeze_message: "Processing... Please wait...",
        callback: function (r) {
            if (r.message === "Failed") {
                if (retryCount < MAX_RETRIES) {
                    processPaymentLink(data, preEnrollmentName, retryCount + 1); // Retry the function
                } else {
                    logClientError({
                        message: "Failed to generate payment link after retries.",
                        data: data,
                        preEnrollmentName: preEnrollmentName
                    });
                    frappe.throw("<b>Payment Link Error</b><br><br>We're sorry, but the payment link you're trying to access is currently unavailable.<br><br><b>What you can do:</b><br>- Try refreshing the page or accessing the link again later.<br>- If the problem persists, please contact our support team for assistance.")
                }
            } else {
                window.location.href = r.message; // Redirect on success
            }
         }
        });
    }

	function save(for_payment) {
		if (frappe.web_form.validate()===false) {
			return false;
		}

		let data = frappe.web_form.get_values();
		if (!data) {
			return false;
		}

		if (window.saving) {
			return false;
		}

		window.saving = true;
		frappe.form_dirty = false;

		frappe.call({
			type: "POST",
			method: "frappe.website.doctype.web_form.web_form.accept",
			args: {
				data: data,
				web_form: frappe.web_form_name,
				for_payment: for_payment
			},
			freeze: true,
			btn: $form.find("[type='submit']"),
			callback: function(data_callback) {
				if(!data_callback.exc) {
					frappe.doc_name = data_callback.message.name;
					if(!frappe.login_required) {
						show_success_message(data, data_callback.message.name);
					}

					if (frappe.enable_online_payment) {
                        processPaymentLink(data, data_callback.message.name, 0);
				    }

					if(frappe.is_new && frappe.login_required) {
						// reload page (with ID)
						window.location.href = window.location.pathname + "?name=" + frappe.doc_name;
					}

					if(for_payment && data.message) {
						// redirect to payment
						window.location.href = data_callback.message;
					}

					// refresh values
					if (frappe.web_form) {
						frappe.web_form.field_group.set_values(data_callback.message);
					}

				} else {
					frappe.msgprint(__('There were errors. Please report this.'));
				}
			},
			always: function() {
				window.saving = false;
			}
		});
		return true;
	}

	function show_success_message(data, preEnrollmentName) {
		$form.addClass("hide");
		$(".comments, .introduction, .page-head").addClass("hide");
		scroll(0, 0);
		set_message(frappe.success_link, true, data, preEnrollmentName);
	}

	function set_message(msg, permanent, data, preEnrollmentName) {
        frappe.call({
            method: "wela.payment_link.enable_online_payment_in_enrollment",
            args:{"web_form": data.web_form_name},
            callback: function(r) {
                var content = '';
               if(r.message[0] == '1' && r.message[1] == '1' && r.message[2] == '1') {
                  var successMessage = msg && msg.trim() !== '' ? msg : '';
                   content += `<div style="
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                padding: 30px;
                                background-color: #fff4f4;
                                border-radius: 12px;
                                box-shadow: 0 4px 20px rgba(0,0,0,0.1);
                                max-width: 600px;
                                margin: 40px auto;
                                text-align: center;
                                font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                            ">
                                ${successMessage}

                                <img src="https://cdn-icons-png.flaticon.com/512/5957/5957350.png" alt="Warning Icon" style="
                                    width: 80px;
                                    height: 80px;
                                    margin-bottom: 20px;
                                ">

                                <h2 style="
                                    font-size: 20px;
                                    color: #d9534f;
                                    margin-bottom: 15px;
                                ">
                                    If you are not automatically redirected to the payment page, please click the button below.
                                </h2>

                                <p style="
                                    font-size: 16px;
                                    color: #6c757d;
                                    margin-bottom: 25px;
                                    line-height: 1.6;
                                ">
                                    This may be due to browser restrictions or a slow network connection.
                                </p>

                                <button id="redirect-btn" style="
                                    background-color: #007bff;
                                    color: white;
                                    padding: 12px 28px;
                                    border: none;
                                    border-radius: 8px;
                                    cursor: pointer;
                                    font-size: 16px;
                                    font-weight: 500;
                                    transition: background-color 0.3s ease, transform 0.2s;
                                "
                                onmouseover="this.style.backgroundColor='#0056b3'; this.style.transform='scale(1.05)'"
                                onmouseout="this.style.backgroundColor='#007bff'; this.style.transform='scale(1)'">
                                    <span style="margin-right: 8px;">🔗</span> Proceed to Payment
                                </button>
                            </div>`;

                	$(".form-message").html(content).removeClass("hide");

                    // Wait until DOM is updated, then bind click
                    setTimeout(function () {
                        var btn = document.getElementById("redirect-btn");
                        if (btn) {
                            btn.addEventListener("click", function () {
                                processPaymentLinkRedirect(data, preEnrollmentName, 0);
                            });
                        }
                    }, 100);
                } else {
                    $(".form-message").html(msg).removeClass("hide");
                }
            }
        });


		if(!permanent) {
			setTimeout(function() {
				$(".form-message").addClass('hide');
			}, 5000);
		}
	}

	// close button
	$(".close").on("click", function() {
		var name = $(this).attr("data-name");
		if(name) {
			frappe.call({
				type:"POST",
				method: "frappe.website.doctype.web_form.web_form.delete",
				args: {
					"web_form": frappe.web_form_name,
					"name": name
				},
				callback: function(r) {
					if(!r.exc) {
						location.reload();
					}
				}
			});
		}
	});
});